// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1f8e27f7","884":"9bca6f6a"}[chunkId] + ".chunk.js";
};